<template>
  <div class="imgsort-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">作品名称</span>
        <el-input
          class="w200"
          maxlength="20"
          style="width:200px; "
          v-model="designName"
          placeholder="请输入作品名称"
        ></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">按月查询</span>
        <el-date-picker v-model="month" type="month" placeholder="选择月"></el-date-picker>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">审核状态</span>
        <el-select
          :loading="categoryLoading"
          clearable
          :disabled="categoryDisabled"
          v-model="checkStatus"
        >
          <el-option label="全部" value></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="审核失败" value="2"></el-option>
        </el-select>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="getImgList">筛选</el-button>
      </div>
      <div class="condition-wrap">
        <el-button type="success" @click="btnAdd">新增作品</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" size="middle" row-key="designId" border stripe>
      <el-table-column prop="name" label="作品名称" align="center" width="100"></el-table-column>
      <el-table-column label="图案" align="center" width="150">
        <template slot-scope="scope">
          <img :src="scope.row.designUrl + '?x-oss-process=image/resize,w_200'" width="100" />
        </template>
      </el-table-column>
      <!-- <el-table-column prop="authorName" label="生产者" align="center"></el-table-column> -->
      <el-table-column label="国家" align="center" width="100">
        <template slot-scope="scope">{{ countryObj[scope.row.countryType] }}</template>
      </el-table-column>
      <el-table-column label="数据类型" align="center">
        <template slot-scope="scope">{{ dataTypeObj[scope.row.dataType] }}</template>
      </el-table-column>
      <!-- <el-table-column label="背景" align="center">
        <template slot-scope="scope">{{ scope.row.baseColor === 'W' ? '白' : '黑' }}</template>
      </el-table-column>-->
      <el-table-column prop="price" label="价格" align="center"></el-table-column>
      <!-- <el-table-column label="状态" align="center" width="140">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>-->
      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.checkStatus == 2"
            @click="searchFailReason(scope.row.checkReason)"
            type="primary"
          >{{ statusObj[scope.row.checkStatus] }}</el-link>
          <span v-else>{{ statusObj[scope.row.checkStatus] }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="下载次数" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.downCount || 0 }}</span>
        </template>
      </el-table-column>-->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="small" type="primary" plain @click="btnEdit(scope.row.designId)">重新编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination
        background
        :page-count="totalPage"
        :current-page="pageNum"
        @current-change="currentChange"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      @close="diaglogClose"
      :title="isEdit ? '编辑作品' : '新增作品'"
      :visible.sync="showAddPop"
      width="500px"
    >
      <el-form :model="addForm" size="small" label-width="120px">
        <el-form-item label="作品名称">
          <el-input v-model="addForm.name" maxlength="30" placeholder="请输入作品名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="生产者">
          <el-autocomplete v-model="addForm.authorName" :fetch-suggestions="queryAuthor" placeholder="请输入内容" hide-loading @select="handleSelectAuthor"></el-autocomplete>
          <span style="color:red;font-size:12px;">注：需要搜索并下拉选择</span>
        </el-form-item>-->
        <el-form-item label="国家">
          <el-select v-model="addForm.countryType">
            <div v-for="item in addCountryList" :key="item.value">
              <el-option :label="item.name" :value="item.value"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="数据类型">
          <el-select :disabled="isBrand" v-model="addForm.dataType" @change="dataChangeAdd">
            <div v-for="item in dataTypeList" :key="item.value">
              <el-option :label="item.name" :value="item.value"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺ID">
          <el-input class="w200" style="width:200px;" @input="addForm.categoryId = ''" @blur="shopBlurAdd" :disabled="addForm.dataType == 1 || isBrand" v-model="addForm.shopId" placeholder="请输入店铺ID"></el-input>
        </el-form-item>-->
        <el-form-item label="分类">
          <el-select
            :loading="addForm.categoryLoading"
            clearable
            :disabled="categoryDisabledAdd"
            v-model="addForm.categoryId"
          >
            <div v-for="item in addForm.categoryList" :key="item.categoryId">
              <el-option :label="item.categoryName" :value="item.categoryId"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="版权方">
          <template>
            <el-radio v-model="addForm.authorType" label="1">自有版权</el-radio>
            <el-radio v-model="addForm.authorType" label="2">所属公司</el-radio>
            <el-input
              v-model="addForm.authorInfo"
              :disabled="addForm.authorType == '1'"
              placeholder="请输入所属公司"
            ></el-input>
          </template>
        </el-form-item>
        <!-- <el-form-item label="状态">
          <el-select v-model="addForm.status" placeholder="请选择">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>-->
        <!-- <el-form-item label="背景颜色">
          <el-select v-model="addForm.baseColor" placeholder="请选择">
            <el-option label="白" value="W"></el-option>
            <el-option label="黑" value="B"></el-option>
          </el-select>
        </el-form-item>-->
        <!-- <el-form-item label="价格">
          <el-input v-model="addForm.price" disabled placeholder="请输入价格">
            <template slot="prepend"
              >￥</template
            >
          </el-input>
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="addForm.level" placeholder="请选择">
            <el-option label="初级会员" :value="1"></el-option>
            <el-option label="中级会员" :value="2"></el-option>
            <el-option label="高级会员" :value="3"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="作品图">
          <el-upload
            class="upload-demo"
            :action="ossUrl"
            :data="addForm.ossDataImg"
            :limit="1"
            :on-success="uploaded"
            :on-change="uploadCg"
            list-type="picture"
            :file-list="addForm.designKeyList"
            accept="image/png"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持png, 小于20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="作品矢量文件">
          <el-upload
            class="upload-demo"
            :action="ossUrl"
            :data="addForm.ossDataPdf"
            :limit="1"
            :on-success="uploadedPdf"
            :on-change="uploadCgPdf"
            accept="application/pdf"
            :file-list="addForm.designPdfList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持pdf, 小于20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="作品介绍">
          <el-upload
            class="upload-demo"
            :action="ossUrl"
            :data="addForm.ossDataFile"
            :limit="1"
            :on-success="uploadedDesc"
            :on-change="uploadCgDesc"
            :file-list="addForm.introduceFileList"
            accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持word, 小于20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="标签">
          <el-button size="small" type="primary" @click="selectTag">选择标签</el-button>
          <span>（可多选）</span>
          <div class="tagList">
            <el-tag
              v-for="(tag, index) in addForm.tagList"
              style="margin-bottom:5px;"
              :key="tag.tagId"
            >{{ tag.tagName }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="作品简介" prop="remark">
          <el-input
            type="textarea"
            :rows="5"
            style="width: 250px!important;"
            maxlength="100"
            placeholder="例：本作品为油画作品，创作于2021年，灵感来源..."
            show-word-limit
            v-model="addForm.remark"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="">
          （含授权范围、二改禁忌、推广要求）
        </el-form-item>-->
        <el-form-item label="授权品类">
          <el-checkbox-group v-model="addForm.extAuthTypeIds">
            <el-checkbox
              v-for="item in authCategoryList"
              :key="item.id"
              :label="item.id"
              name="type"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="设计要求">
          <el-radio-group @change="addForm.designRequirement=''" v-model="addForm.designRequirementId">
            <el-radio v-for="item in designRequirementList" :key="item.id" :label="item.id">{{item.name}}</el-radio>
          </el-radio-group>
          <el-input :disabled="addForm.designRequirementId == 6"  placeholder="请输入设计要求" v-model="addForm.designRequirement"></el-input>
        </el-form-item>
        <el-form-item label="推广应用">
          <el-checkbox-group v-model="addForm.extensionAppIds">
            <el-checkbox v-for="item in appList" :key="item.id" :label="item.id" name="type">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button @click="showAddPop = false">取 消</el-button>
        <el-button type="primary" @click="addDesign">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择标签" :visible.sync="innerDiaglog" width="600px">
      <div class="table-wrap" ref="tableWrap" style="height:407px;overflow-y:auto;">
        <el-table
          ref="multipleTable"
          :data="showTagList"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="tagName" label="标签名称"></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button type="primary" @click="innerDiaglog=false">完 成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "../lib/API";
import { dataTypeList, countryList } from "../lib/constObj.js";
import dayjs from "dayjs";
export default {
  name: "OrderList",
  data() {
    return {
      tableData: [],
      content: "",
      categoryId: "",
      pageNum: 1,
      totalPage: 0,
      showAddPop: false,
      ossUrl: "",
      isBrand: true,
      shopId: "",
      categoryLoading: false,
      ossData: {},
      statusObj: {
        0: "待审核",
        1: "审核通过",
        2: "审核失败"
      },
      addForm: {
        authorId: "",
        countryType: "2",
        baseColor: "W",
        categoryId: "",
        designKey: "",
        designPdf: "",
        introduceFile: "",
        ossDataImg: {},
        ossDataPdf: {},
        ossDataFile: {},
        designKeyList: [],
        designPdfList: [],
        introduceFileList: [],
        designRequirementId: "",
        designRequirement: "",
        extAuthTypeIds: [],
        extensionAppIds: [],
        status: 0,
        name: "",
        authorName: "",
        authorType: "1",
        price: 1,
        level: 1,
        tagName: "",
        tagIds: [],
        tagList: [],
        remark: "",
        authorInfo: "",
        categoryList: [],
        // shopId: '',
        dataType: "1",
        categoryLoading: false
      },
      showTagList: [],
      countryList: countryList,
      dataTypeList: dataTypeList,
      categoryList: [],
      countryType: "1",
      dataType: "1",
      countryObj: {},
      dataTypeObj: {},
      isEdit: false,
      addCountryList: [],
      innerDiaglog: false,
      designName: "",
      month: "",
      checkStatus: "",
      designRequirementList: [],
      authCategoryList: [],
      appList: []
    };
  },
  computed: {
    categoryDisabled() {
      if (this.dataType === "1" || (this.dataType === "2" && this.shopId)) {
        return false;
      }
      return true;
    },
    categoryDisabledAdd() {
      if (
        this.addForm.dataType === "1" ||
        (this.addForm.dataType === "2" && this.addForm.shopId)
      ) {
        return false;
      }
      return true;
    }
  },
  methods: {
    searchFailReason(reason) {
      this.$alert(reason, "失败原因");
    },
    selectTag() {
      this.innerDiaglog = true;
      this.$nextTick(() => {
        this.defaultSelect();
      });
    },
    defaultSelect() {
      let originTagIds = JSON.parse(JSON.stringify(this.addForm.tagIds));
      this.$refs.multipleTable.clearSelection();
      originTagIds.forEach(tagId => {
        let row = this.showTagList.find(item => item.tagId == tagId);
        row && this.$refs.multipleTable.toggleRowSelection(row);
      });
    },
    handleSelectionChange(rows) {
      this.addForm.tagList = rows;
      this.addForm.tagIds = this.addForm.tagList.map(item => item.tagId);
    },
    deleteTag(index) {
      this.addForm.tagList.splice(index, 1);
      this.addForm.tagIds.splice(index, 1);
    },
    handleSelect(item) {
      if (item.tagId === -1) {
        this.addForm.tagName = "";
        return;
      }
      if (this.addForm.tagIds.includes(item.tagId)) {
        return this.$message.error("标签重复");
      }
      this.addForm.tagList.push(item);
      this.addForm.tagIds.push(item.tagId);
      this.addForm.tagName = "";
    },
    querySearchAsync(tagName, cb) {
      console.log(tagName);
      if (!tagName) {
        return cb([]);
      }
      new API(this).POST({
        url: "/tag/listWithPage",
        params: {
          count: true,
          pageNum: 1,
          pageSize: 100,
          tagName
        },
        cb: res => {
          res.result.forEach(item => {
            item.value = item.tagName;
          });
          if (!res.result.length) {
            res.result = [{ value: "无匹配数据", tagId: -1 }];
          }
          cb(res.result);
        }
      });
    },
    handleSelectAuthor(item) {
      if (item.authorId === -1) {
        this.addForm.authorId = "";
        this.addForm.authorName = "";
      }
      this.addForm.authorId = item.authorId;
    },
    queryAuthor(queryString, cb) {
      if (!queryString) {
        return cb([]);
      }
      new API(this).POST({
        url: "/author/listWithPage",
        params: {
          count: true,
          pageNum: 1,
          pageSize: 100,
          authorName: queryString
        },
        cb: res => {
          let { pages, result } = res;
          result.forEach(item => {
            item.value = item.authorName;
          });
          if (!result.length) {
            result = [{ value: "无匹配数据", authorId: -1 }];
          }
          cb(result);
        }
      });
    },
    btnAdd() {
      this.isEdit = false;
      this.showAddPop = true;
      this.ossUrl = "";
      this.ossData = {};
      this.getOss();
    },
    shopBlur() {
      if (this.shopId) {
        this.getCategoryList();
      }
    },
    shopBlurAdd() {
      if (this.addForm.shopId) {
        this.getCategoryListAdd();
      }
    },
    btnEdit(id) {
      this.btnAdd();
      this.isEdit = true;
      new API(this).POST({
        url: "/design/getDesignDetail?designId=" + id,
        cb: res => {
          Object.assign(this.addForm, res);
          res.author = res.author || {};
          this.addForm.tagList = res.tags;
          this.addForm.tagIds = res.tags.map(item => item.tagId);
          this.addForm.authorName = res.author.authorName;
          this.addForm.dataType = String(res.category.dataType);
          this.addForm.shopId = res.category.shopId;
          this.addForm.price = res.price || 1;
          this.addForm.categoryId = res.category.categoryId;
          this.addForm.designKeyList = [
            { name: this.getFileName(res.designKey), url: res.designUrl }
          ];
          if (res.designPdf) {
            this.addForm.designPdfList = [
              { name: this.getFileName(res.designPdf), url: res.designPdfUrl }
            ];
          } else {
            this.addForm.designPdfList = [];
          }
          if (res.introduceFile) {
            this.addForm.introduceFileList = [
              {
                name: this.getFileName(res.introduceFile),
                url: res.introduceFileUrl
              }
            ];
          } else {
            this.addForm.introduceFileList = [];
          }
          this.getCategoryListAdd();
        }
      });
    },
    getFileName(str) {
      return str.split("/").pop();
    },
    dataChangeAdd() {
      console.log("dataChangeAdd");
      this.addForm.shopId = "";
      this.addForm.categoryList = [];
      this.addForm.categoryId = "";
      if (this.addForm.dataType === "1") {
        this.getCategoryListAdd();
      }
    },
    dataChange() {
      this.shopId = "";
      this.categoryList = [];
      this.categoryId = "";
      if (this.dataType === "1") {
        this.getCategoryList();
      }
    },
    getOss() {
      new API(this).POST({
        url: "/oss/getSignature",
        params: {
          count: 1,
          type: 5
        },
        cb: res => {
          this.ossUrl = res.url;
          this.ossData = JSON.parse(JSON.stringify(res.signatures[0]));
          this.addForm.ossDataImg = JSON.parse(
            JSON.stringify(res.signatures[0])
          );
          this.addForm.ossDataPdf = JSON.parse(
            JSON.stringify(res.signatures[0])
          );
          this.addForm.ossDataFile = JSON.parse(
            JSON.stringify(res.signatures[0])
          );
        }
      });
    },
    diaglogClose() {
      this.addForm = {
        countryType: "2",
        baseColor: "W",
        categoryId: "",
        designKey: "",
        designPdf: "",
        introduceFile: "",
        ossDataImg: {},
        ossDataPdf: {},
        ossDataFile: {},
        designKeyList: [],
        designPdfList: [],
        introduceFileList: [],
        designRequirementId: "",
        designRequirement: "",
        extAuthTypeIds: [],
        extensionAppIds: [],
        status: 0,
        name: "",
        authorName: "",
        authorType: "1",
        price: 1,
        level: 1,
        tagName: "",
        tagIds: [],
        tagList: [],
        remark: "",
        authorInfo: "",
        categoryList: [],
        shopId: "",
        dataType: "1",
        categoryLoading: false,
        authorId: this.addForm.authorId
      };
      this.getCategoryListAdd();
      this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
      let tableWrap = this.$refs.tableWrap;
      if (tableWrap) tableWrap.scrollTop = 0;
    },
    currentChange(val) {
      this.pageNum = val;
      this.getImgList();
    },
    getImgList() {
      let createTimeStart = "";
      let createTimeEnd = "";
      if (this.month) {
        let date = dayjs(this.month).format("YYYY-MM-DD");
        createTimeStart = `${date} 00:00:00`;
        let year = this.month.getFullYear();
        let month = this.month.getMonth();
        let endDate = new Date(year, month + 1, 0);
        createTimeEnd = `${dayjs(endDate).format("YYYY-MM-DD")} 23:59:59`;
      }
      new API(this).POST({
        url: "/design/findDesignListWithAuthor",
        params: {
          authorId: this.authorId,
          count: true,
          pageNum: this.pageNum,
          pageSize: 10,
          createTimeStart,
          createTimeEnd,
          name: this.designName,
          checkStatus: this.checkStatus
        },
        cb: res => {
          let { pages, result } = res;
          this.totalPage = pages;
          this.tableData = result;
        }
      });
    },
    getCategoryList() {
      this.categoryLoading = true;
      // 图案分类
      new API(this).POST({
        url: "/designCategory/findAllEndableDesignCategoryList",
        params: {
          dataType: this.dataType,
          shopId: this.shopId
        },
        cb: res => {
          this.categoryList = res;
          this.categoryLoading = false;
        }
      });
    },
    getCategoryListAdd() {
      this.addForm.categoryLoading = true;
      // 图案分类
      new API(this).POST({
        url: "/designCategory/findAllEndableDesignCategoryList",
        params: {
          dataType: this.addForm.dataType,
          shopId: this.addForm.shopId
        },
        cb: res => {
          this.addForm.categoryList = res;
          this.addForm.categoryLoading = false;
        }
      });
    },
    addDesign() {
      let {
        authorInfo,
        authorId,
        price,
        designPdf,
        baseColor,
        categoryId,
        designKey,
        name,
        authorType,
        countryType,
        designRequirementId,
        extAuthTypeIds,
        extensionAppIds,
      } = this.addForm;
      if (!name) {
        this.$message.error("请填写作品名称~");
        return;
      }
      // if (!authorId) {
      //   this.$message.error('请选择生产者~')
      //   return
      // }
      if (!countryType) {
        this.$message.error("请选择国家~");
        return;
      }
      if (!categoryId) {
        this.$message.error("请选择分类~");
        return;
      }
      if (authorType == "2" && !authorInfo) {
        this.$message.error("请填写公司信息~");
        return;
      }
      // if (!baseColor) {
      //   this.$message.error('请选择背景颜色~')
      //   return
      // }
      if (!price) {
        this.$message.error("请输入价格~");
        return;
      }
      if (!designKey) {
        this.$message.error("请上传作品图~");
        return;
      }
      if (!designPdf) {
        this.$message.error("请上传作品矢量文件~");
        return;
      }
      if (!extAuthTypeIds.length) {
        this.$message.error("请选择授权品类~");
        return
      }
      if (!designRequirementId) {
        this.$message.error("请选择设计要求~");
        return
      }
      if (!extensionAppIds.length) {
        this.$message.error("请选择推广应用~");
        return
      }
      let url = this.isEdit ? "/design/updateDesign" : "/design/addDesign";
      delete this.addForm.categoryName;
      new API(this).POST({
        url,
        params: this.addForm,
        cb: res => {
          if (res === null) {
            this.getImgList();
            this.showAddPop = false;
          }
        }
      });
    },
    uploaded(val) {
      this.addForm.designKey = this.addForm.ossDataImg.key;
    },
    uploadedPdf(val) {
      this.addForm.designPdf = this.addForm.ossDataPdf.key;
    },
    uploadedDesc(val) {
      this.addForm.introduceFile = this.addForm.ossDataFile.key;
    },
    uploadCg(file) {
      this.uploadCgDeal(file, "ossDataImg");
    },
    uploadCgPdf(file) {
      this.uploadCgDeal(file, "ossDataPdf");
    },
    uploadCgDesc(file) {
      this.uploadCgDeal(file, "ossDataFile");
    },
    uploadCgDeal(file, attr) {
      console.log(file);
      let ext = file.raw.type;
      ext = ext ? "." + ext.split("/")[1] : "";
      if (ext.includes("msword")) {
        ext = ".doc";
      } else if (
        ext.includes(
          "vnd.openxmlformats-officedocument.wordprocessingml.document"
        )
      ) {
        ext = ".docx";
      }
      let hasExt = this.ossData.key.indexOf(".");
      if (hasExt === -1) {
        this.addForm[attr]["key"] = this.ossData.key + ext;
      } else {
        this.addForm[attr]["key"] = this.ossData.key.slice(0, hasExt);
        this.addForm[attr]["key"] += ext;
      }
    },
    editImg() {
      new API(this).POST({
        url: "/design/updateDesign",
        params: this.editForm,
        cb: res => {
          if (res === null) {
            location.reload();
          }
        }
      });
    },
    dealObj() {
      this.dataTypeList.forEach(item => {
        this.dataTypeObj[item.value] = item.name;
      });
      this.countryList.forEach(item => {
        this.countryObj[item.value] = item.name;
      });
    },
    getTagList() {
      new API(this).POST({
        url: "/tag/findTagList",
        cb: res => {
          this.showTagList = res;
        }
      });
    },
    getAuthCategoryList() {
      new API(this).POST({
        url: "/designExtType/findAuthType",
        cb: res => {
          this.authCategoryList = res;
        }
      });
    },
    getAppList() {
      new API(this).POST({
        url: "/designExtType/findExtensionApp",
        cb: res => {
          this.appList = res;
        }
      });
    },
    getDesignList() {
      new API(this).POST({
        url: "/designExtType/findDesignRequirement",
        cb: res => {
          this.designRequirementList = res;
        }
      });
    }
  },
  created() {
    // // 图案查询
    // this.getImgList();
    // 如果是品牌商不让选择数据类型和店铺id
    this.dealObj();

    this.isBrand = localStorage.getItem("roleId") === "4";
    this.addForm.authorId = localStorage.getItem("authorId");
    if (this.isBrand) {
      this.shopId = localStorage.getItem("shopId");
      this.dataType = "2";
    }
    this.getCategoryList();
    this.getCategoryListAdd();
    this.addCountryList = this.countryList.slice(1);
    this.getImgList();
    this.getTagList();
    this.getAuthCategoryList();
    this.getAppList();
    this.getDesignList();
  }
};
</script>
<style scoped>
.tagList {
  margin-top: 10px;
}
.tagList /deep/ .el-tag {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyIpManage.vue